export const MASK_SELECTORS_FROM_SESSSION_REPLAY = ['[data-application-name="in-app-help-ui"]', '[data-test-id="unified-auth-form"]'];